@if (!editMode || editReadOnly) {
  <div>{{ displayCurrencyCode }} {{ displayMoneyValue }}</div>
} @else {
  @if (internalFormGroup) {
    <form [formGroup]="internalFormGroup" class="main-form-container">
      <div class="elements">
        <mat-select formControlName="currency" class="select-container" [compareWith]="compareFunction">
          @for (currency of currencies; track currency) {
            <mat-option [value]="currency">
              {{ currency.code }}
            </mat-option>
          }
        </mat-select>
      </div>
      <div class="form-container">
        <div class="adjust-elements">
          <mat-form-field>
            <input formControlName="valueMain" type="text" pattern="{{ '[0-9]{0}' }}" matInput />
          </mat-form-field>
        </div>
      </div>
      @if (shouldDisplaySmallUnit()) {
        <div class="info-dot">.</div>
        <div class="info-elements">
          <mat-form-field>
            <input
              formControlName="valueSmall"
              type="text"
              pattern="{{ '[0-9]{' + this.numberOfDecimalPlaces + '}' }}"
              matInput />
          </mat-form-field>
        </div>
      }
    </form>
  }
}
